import React from "react";
import { Phone, Mail, Globe, MapPin } from "lucide-react";

const CardLogo = () => (
  <svg width="46" height="46" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M24 4L44 18V20H4V18L24 4Z" fill="#C59B27" />
    <rect x="8" y="20" width="32" height="24" rx="2" fill="#FFFFFF" />
    <path d="M8 30H40" stroke="#C59B27" strokeWidth="2.4" />
    <path d="M24 20V44" stroke="#C59B27" strokeWidth="2.4" />
    <rect x="20" y="24" width="8" height="4" rx="1" fill="#C59B27" />
  </svg>
);

export const DEFAULT_CARD = {
  name: "Dan Waters",
  title: "Founder & Lead Organizer",
  phone: "(850) 555-0142",
  email: "hello@pack2perfect.com",
  website: "pack2perfect.com",
  tagline: "From Moving Chaos to Turnkey Peace",
};

export const BusinessCardMock = ({ card = DEFAULT_CARD }) => (
  <div id="card-print-area" className="space-y-8">
    {/* FRONT */}
    <div>
      <div className="text-xs uppercase tracking-[0.18em] text-brand-slate mb-2 font-semibold no-print-label">Front</div>
      <div data-testid="business-card-front"
           className="relative w-full max-w-[520px] aspect-[1.75/1] rounded-2xl overflow-hidden shadow-2xl bg-brand-ceruleanDark">
        <div className="absolute inset-0" style={{ background: "radial-gradient(120% 100% at 100% 0%, rgba(197,155,39,0.28), transparent 55%)" }} />
        <div className="absolute -right-10 -bottom-12 w-56 h-56 rounded-full" style={{ background: "rgba(197,155,39,0.10)" }} />
        <div className="absolute top-0 left-0 right-0 h-1.5 bg-brand-gold" />
        <div className="relative h-full p-7 flex flex-col justify-between">
          <div className="flex items-center gap-3">
            <CardLogo />
            <div>
              <div className="font-serif text-white text-2xl leading-none font-semibold">Pack 2 Perfection</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-brand-gold mt-1.5">Pensacola • Emerald Coast</div>
            </div>
          </div>
          <div>
            <div className="font-serif italic text-white/90 text-lg leading-tight">"{card.tagline}"</div>
            <div className="mt-3 flex items-center gap-2 text-[11px] text-white/60">
              <span className="h-px w-8 bg-brand-gold/60" />
              Concierge Packing • Unpacking • Organization • Staging
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* BACK */}
    <div>
      <div className="text-xs uppercase tracking-[0.18em] text-brand-slate mb-2 font-semibold no-print-label">Back</div>
      <div data-testid="business-card-back"
           className="relative w-full max-w-[520px] aspect-[1.75/1] rounded-2xl overflow-hidden shadow-2xl bg-white border border-brand-border">
        <div className="absolute top-0 left-0 bottom-0 w-2 bg-brand-cerulean" />
        <div className="absolute top-0 left-0 bottom-0 w-2.5 ml-2 bg-brand-gold" />
        <div className="relative h-full pl-9 pr-7 py-6 flex flex-col justify-between">
          <div className="flex items-start justify-between">
            <div>
              <div className="font-serif text-2xl text-brand-navy font-semibold leading-none">{card.name}</div>
              <div className="text-xs uppercase tracking-[0.16em] text-brand-gold mt-1.5 font-semibold">{card.title}</div>
            </div>
            <CardLogo />
          </div>
          <div className="space-y-1.5">
            <div className="flex items-center gap-2.5 text-sm text-brand-navy"><Phone className="w-4 h-4 text-brand-cerulean" /> {card.phone}</div>
            <div className="flex items-center gap-2.5 text-sm text-brand-navy"><Mail className="w-4 h-4 text-brand-cerulean" /> {card.email}</div>
            <div className="flex items-center gap-2.5 text-sm text-brand-navy"><Globe className="w-4 h-4 text-brand-cerulean" /> {card.website}</div>
            <div className="flex items-center gap-2.5 text-sm text-brand-slate"><MapPin className="w-4 h-4 text-brand-cerulean" /> Escambia & Santa Rosa County, FL</div>
          </div>
          <div className="flex items-center justify-between border-t border-brand-border pt-2.5">
            <span className="text-[10px] uppercase tracking-[0.18em] text-brand-slate">Licensed & Bonded in Florida</span>
            <span className="text-[10px] text-brand-gold font-semibold">Zero-Stress Move Guarantee</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);
